import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'flo-video-grid',
  styleUrls: ['./video-grid.component.scss'],
  templateUrl: './video-grid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoGridComponent {
  @Input()
  set notFoundWarning(value: string) {
    this._notFoundWarning = value
  }

  get notFoundWarning() {
    return this._notFoundWarning || "Sorry, we don't have any results for that"
  }

  @Input()
  set videos(value: ReadonlyArray<any>) {
    this._videos = value
  }

  get videos() {
    return this._videos || []
  }

  get showVideos() {
    return this.videos.length > 0
  }
  private _videos: ReadonlyArray<any>
  private _notFoundWarning: string

  @Output() readonly selectionChange = new EventEmitter<any>()
  // tslint:disable:no-output-native
  @Output() readonly change = new EventEmitter<any>()

  @Input() selectionMode = false
  @Input() queryParamsHandling = 'preserve'
  @Input() target = '_self'
  @Input() fullScreen = 'col-md-4'
  @Input() queryParamsFn = (input: any) => ({})
  @Input() analyticsPropertiesFn = (input: any) => ({})

  hitSpotlight(video: any) {
    this.selectionChange.next(video)
  }

  public trackByVideos(index: number, video: any): number {
    return video.id
  }
}
